import React, { useState, useEffect } from 'react';
import api from './api';
import RoughDetailModal from './RoughDetailModal';

const RoughStock = () => {
    const [lots, setLots] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedLot, setSelectedLot] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const fetchStock = async () => {
        try {
            const res = await api.get('/rough');
            // FILTER: Only show 'Rough' status AND Weight > 0
            const active = res.data.data.filter(l => l.status === 'Rough' && l.weight > 0.009); 
            setLots(active);
            setLoading(false);
        } catch (err) { setLoading(false); }
    };

    useEffect(() => { fetchStock(); }, []);

    const totalCts = lots.reduce((acc, lot) => acc + lot.weight, 0);
    const totalValue = lots.reduce((acc, lot) => acc + lot.landedCost, 0);

    const formatNumber = (num) => (num || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    return (
        <div className="container mt-4 mb-5">
            <h4 className="fw-bold mb-3">Current Stock (In Safe)</h4>

            {/* STATS */}
            <div className="row mb-4 g-2">
                <div className="col-4">
                    <div className="card bg-primary text-white text-center p-2 h-100">
                        <small>Total Weight</small>
                        <h5 className="mb-0">{formatNumber(totalCts)} <span style={{fontSize:'0.6em'}}>Cts</span></h5>
                    </div>
                </div>
                <div className="col-4">
                    <div className="card bg-success text-white text-center p-2 h-100">
                        <small>Total Value</small>
                        <h5 className="mb-0">₹ {Math.round(totalValue).toLocaleString('en-IN')}</h5>
                    </div>
                </div>
                <div className="col-4">
                    <div className="card bg-light text-center p-2 border h-100">
                        <small>Packets</small>
                        <h5 className="mb-0">{lots.length}</h5>
                    </div>
                </div>
            </div>

            {/* DESKTOP TABLE */}
            <div className="card shadow-sm border-0 d-none d-md-block">
                <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0">
                        <thead className="table-dark">
                            <tr>
                                <th>Lot No</th>
                                <th>Date</th>
                                {/* CHANGED COLUMN HEADER */}
                                <th>Origin / Sieve</th> 
                                <th>Source</th>
                                <th className="text-end">Weight</th>
                                <th className="text-end">Cost / Ct</th>
                                <th className="text-end">Value (₹)</th>
                                <th className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="8" className="text-center p-4">Loading...</td></tr>
                            ) : lots.length === 0 ? (
                                <tr><td colSpan="8" className="text-center p-4 text-muted">Safe is Empty!</td></tr>
                            ) : (
                                lots.map(lot => (
                                    <tr key={lot._id}>
                                        <td className="fw-bold text-primary">{lot.rpNumber}</td>
                                        <td><small>{new Date(lot.purchaseDate).toLocaleDateString('en-GB')}</small></td>
                                        
                                        {/* CHANGED: SHOW ORIGIN & SIEVE INSTEAD OF PARTY */}
                                        <td className="fw-bold" style={{fontSize:'0.9rem'}}>
                                            <div>{lot.origin || '-'}</div>
                                            <div className="text-muted small fw-normal">{lot.sieveSize || '-'}</div>
                                        </td>

                                        <td><span className={`badge ${lot.sourceType === 'Import' ? 'bg-warning text-dark' : 'bg-light text-dark border'}`}>{lot.sourceType}</span></td>
                                        
                                        <td className="text-end fw-bold">{formatNumber(lot.weight)}</td>
                                        <td className="text-end text-muted">{formatNumber(lot.costPerCarat)}</td>
                                        <td className="text-end fw-bold">{formatNumber(lot.landedCost)}</td>
                                        <td className="text-center">
                                            <button className="btn btn-sm btn-outline-secondary" onClick={() => { setSelectedLot(lot); setShowModal(true); }}>👁️</button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* MOBILE CARDS */}
            <div className="d-block d-md-none">
                {lots.map(lot => (
                    <div key={lot._id} className="card mb-3 shadow-sm border-0" onClick={() => { setSelectedLot(lot); setShowModal(true); }}>
                        <div className="card-body p-3">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6 className="mb-0 fw-bold text-primary">{lot.rpNumber}</h6>
                                {/* CHANGED: SHOW ORIGIN & SIEVE BADGE */}
                                <span className="badge bg-light text-dark border text-truncate" style={{maxWidth:'150px'}}>
                                    {lot.origin} ({lot.sieveSize})
                                </span>
                            </div>
                            <div className="bg-light rounded p-2">
                                <div className="row text-center g-0">
                                    <div className="col-4 border-end">
                                        <small className="d-block text-muted" style={{fontSize:'0.7rem'}}>Weight</small>
                                        <strong>{formatNumber(lot.weight)}</strong>
                                    </div>
                                    <div className="col-4 border-end">
                                        <small className="d-block text-muted" style={{fontSize:'0.7rem'}}>Cost/Ct</small>
                                        <strong>{Math.round(lot.costPerCarat).toLocaleString('en-IN')}</strong>
                                    </div>
                                    <div className="col-4">
                                        <small className="d-block text-muted" style={{fontSize:'0.7rem'}}>Value</small>
                                        <strong className="text-success">{Math.round(lot.landedCost/1000).toLocaleString()}k</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <RoughDetailModal show={showModal} onClose={() => setShowModal(false)} lot={selectedLot} />
        </div>
    );
};
export default RoughStock;